export const credits = {
    credits: "만든 사람들",
    license: "이용 약관",
    privacyPolicy: "개인정보취급방침",
    contact: "문의하기",
}
